import { useContext } from 'react'
import { GlobalContext } from 'App'
import { motion } from 'framer-motion';
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'constants/animation-properties';

const First = ({ data }: any) => {
  const { isTablet } = useContext(GlobalContext)

  return (
    <section className='mb-24 min-h-screen'>
      <div
        id='change'
        style={{
          backgroundImage: `url(${data.detail})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
        }}
        className="flex flex-col justify-center items-center gap-8 tablet:gap-4 w-full h-[60vh] tablet:h-screen font-bold text-white"
      >
        <motion.div
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          {
            data.logo &&
            <data.logo />
          }
        </motion.div>

        <motion.div
          className='flex flex-col items-center gap-2'
          transition={{ delay: 0.2 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          <p className='text-[#949494] tablet:text-lg text-2xl'>{data.period}</p>
          <p className='tablet:text-2xl text-3xl'>{data.name}</p>
        </motion.div>

        <motion.div
          className='flex flex-col items-center gap-5 tablet:gap-2'
          transition={{ delay: 0.4 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          <p className='text-[#949494] tablet:text-lg text-2xl'>{data.type}</p>
          <p className='text-[#949494] tablet:text-lg text-2xl tablet:text-center'>{data.descriptionEn}</p>
        </motion.div>
      </div>

      <div className='flex tablet:flex-col justify-evenly items-center gap-4 py-18 tablet:py-4 h-[40vh] tablet:h-auto container'>
        <motion.div
          className='flex flex-col flex-1 gap-6'
          transition={{ delay: 0.6 }}
          initial={START_ANIMATION_PROPERTY}
          whileInView={END_ANIMATION_PROPERTY}
          viewport={VIEWPORT_PROPERTY} >
          <img src={data.keyPointImg} alt="키포인트" />
        </motion.div>


        <div className='flex flex-col flex-1 gap-6 tablet:gap-4'>
          <motion.h2
            className='font-semibold text-black tablet:text-lg text-2xl'
            transition={{ delay: 0.6 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            Service Key Points
          </motion.h2>

          <motion.div
            transition={{ delay: 0.8 }}
            initial={START_ANIMATION_PROPERTY}
            whileInView={END_ANIMATION_PROPERTY}
            viewport={VIEWPORT_PROPERTY} >
            <p className='font-semibold text-[#727272] tablet:text-base line' style={{ lineHeight: 1.8 }} dangerouslySetInnerHTML={{ __html: isTablet ? data.keyPoint.replace(/<br\s*\/?>/gi, '') : data.keyPoint }}></p>
          </motion.div>
        </div>

      </div>
    </section>
  )
}

export default First
